export default __webpack_public_path__ + "static/favour-f3fcaf8dffcf52e793246a0d759a5b4d.png";